import React from 'react';
import styled from 'styled-components';
import { Controller, useFormContext } from 'react-hook-form';
import { FormComponentProps } from 'types/components';
import {
  TextArea,
  TextAreaProps,
} from 'up-ops-web-shared-components/lib/components/inputs/text-area';

type FormTextAreaProps = FormComponentProps & TextAreaProps;

const FormTextArea = ({
  defaultValue = '',
  name,
  rules,
  ...props
}: FormTextAreaProps) => {
  const { control, formState } = useFormContext();

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field, fieldState }) => {
        const { onBlur, onChange, ref, value } = field;
        const { error, invalid } = fieldState;
        return (
          <TextArea
            disabled={formState.isSubmitting}
            error={invalid}
            hint={error?.message}
            innerRef={ref}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            {...props}
          />
        );
      }}
      rules={rules}
    />
  );
};

export const FullWidthTextArea = styled(FormTextArea)`
  & > div {
    width: 100%;
  }
`;

export default FormTextArea;
